/**
 * 支付助手：查询订单（到账 / 失败类型）
 * GET {STORE_HOST}payment_assistant/get_orders
 */

import { getJSON, STORE_HOST } from '@store/officialTopupNew/ultile';
import { gameIdTransform } from '@utiles/officialTopupNew/transform';

/**
 * 结果页 URL result=0 时轮询间隔（毫秒）
 */
export const PAY_FAIL_ORDER_POLL_INTERVAL_MS = 60 * 1000;

/** 最多轮询次数（默认 1min × 20 ≈ 20min） */
export const PAY_FAIL_ORDER_POLL_MAX_ATTEMPTS = 20;

/**
 * 购物车订单查 payment_assistant/get_orders 时在订单号末尾拼 '1'
 * 例：ZTMSLG260812211408539560C → ZTMSLG260812211408539560C1
 * @param {string|number} [orderId]
 * @param {boolean} [isCart]
 */
export function resolvePaymentAssistantOrderId(orderId, isCart) {
  if (!orderId || !isCart) return orderId;
  return `${orderId}1`;
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

let times = 0

/**
 * @param {{ gameId: string|number, orderId?: string }} options
 * @returns {Promise<Array<Record<string, unknown>>>}
 */
export async function fetchPaymentAssistantOrders(options = {}) {
  times++
  const { gameId, orderId } = options;
  const params = gameIdTransform({ game_id: gameId });
  if (orderId) {
    params.order_id = orderId;
  }

  const { errmsg, data } = await getJSON(
    `${STORE_HOST}payment_assistant/get_orders`,
    params,
  );
  if (errmsg) {
    throw new Error(errmsg);
  }


  const list = data && data.list
  return Array.isArray(list) ? list : [];
}

/**
 * @param {Array<Record<string, unknown>>} list
 * @param {string} [orderId]
 * @returns {Record<string, unknown> | null}
 */
export function pickPaymentAssistantOrder(list, orderId) {
  if (!Array.isArray(list) || !list.length) return null;
  if (orderId) {
    const target = String(orderId);
    const matched = list.find(
      (item) => item && String(item.order_id) === target,
    );
    if (matched) return matched;
  }
  return list[0] || null;
}

/**
 * URL result=0 时轮询订单，直到接口 result !== 0 或达到上限
 * @param {{
 *   gameId: string|number,
 *   orderId?: string,
 *   intervalMs?: number,
 *   maxAttempts?: number,
 *   shouldContinue?: () => boolean,
 * }} options
 * @returns {Promise<Record<string, unknown> | null>} 终态订单；超时仍为 0 则 null
 */
export async function pollPaymentAssistantOrder(options = {}) {
  const {
    gameId,
    orderId,
    intervalMs = PAY_FAIL_ORDER_POLL_INTERVAL_MS,
    maxAttempts = PAY_FAIL_ORDER_POLL_MAX_ATTEMPTS,
    shouldContinue = () => true,
  } = options;

  if (!gameId) return null;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    if (!shouldContinue()) return null;

    try {
      const list = await fetchPaymentAssistantOrders({ gameId, orderId });
      const order = pickPaymentAssistantOrder(list, orderId);
      if (order && Number(order.result) !== 0) {
        return order;
      }
    } catch (err) {
      console.warn('[PayFailTip] poll get_orders failed', err);
    }

    if (attempt < maxAttempts - 1 && shouldContinue()) {
      await delay(intervalMs);
    }
  }

  return null;
}
